import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

const SupportCases = () => {
  const { t } = useTranslation();
  return (
    <Box className="p-4">
      <Paper className="p-6">
        <Typography variant="h5" gutterBottom>
          {t("ownerScreens.supportCases")}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t("ownerScreens.supportCasesDesc")}
        </Typography>
      </Paper>
    </Box>
  );
};

export default SupportCases;
